import { gql } from '@apollo/client';
import { AccountDeliveryDriverType } from '../../types/AccountDeliveryDriverType';
import { ACCOUNTS_PAGE_MODE, AccountsPageMode } from '../../hooks/useAccountDeliveryDriverQuery';

const ACCOUNT_DELIVERY_DRIVER_BY_IDS_FIELDS = gql`
    fragment AccountDeliveryDriverByIdsFields on AccountDeliveryDriverType {
        id
        accountId
        dspId
        driverLicenseNumber
        vehicleTypeId
        vehiclePlate
        isOnDuty
        vehicleImageS3KeysJson
        vehicleImageUrls
        idDocumentType
        idDocumentNumber
        idDocumentImageS3KeysJson
        idDocumentImageUrls
        createdAt
        updatedAt
        account {
            id
            name
            countryCode
            phone
            email
            status
        }
        dsp {
            id
            name
            dspCode
        }
    }
`;

// DSP 入口
export const GET_ACCOUNT_DELIVERY_DRIVERS_BY_IDS_FOR_DSP = gql`
    query GetAccountDeliveryDriversByIdsForDsp($accountIds: [Long!]!) {
        getAccountDeliveryDriversByIds: getAccountDeliveryDriversByIdsForDsp(accountIds: $accountIds) {
            ...AccountDeliveryDriverByIdsFields
        }
    }
    ${ACCOUNT_DELIVERY_DRIVER_BY_IDS_FIELDS}
`;

// 总部入口
export const GET_ACCOUNT_DELIVERY_DRIVERS_BY_IDS_FOR_CENTRAL = gql`
    query GetAccountDeliveryDriversByIdsForCentral($accountIds: [Long!]!) {
        getAccountDeliveryDriversByIds: getAccountDeliveryDriversByIdsForCentral(accountIds: $accountIds) {
            ...AccountDeliveryDriverByIdsFields
        }
    }
    ${ACCOUNT_DELIVERY_DRIVER_BY_IDS_FIELDS}
`;

// 仓库入口
export const GET_ACCOUNT_DELIVERY_DRIVERS_BY_IDS_FOR_WMS = gql`
    query GetAccountDeliveryDriversByIdsForWms($accountIds: [Long!]!, $warehouseId: Long!) {
        getAccountDeliveryDriversByIds: getAccountDeliveryDriversByIdsForWms(accountIds: $accountIds, warehouseId: $warehouseId) {
            ...AccountDeliveryDriverByIdsFields
        }
    }
    ${ACCOUNT_DELIVERY_DRIVER_BY_IDS_FIELDS}
`;

export interface GetAccountDeliveryDriversByIdsResponse {
    getAccountDeliveryDriversByIds: AccountDeliveryDriverType[];
}

export const getAccountDeliveryDriversByIds = async (
    accountIds: number[],
    mode?: AccountsPageMode,
    warehouseId?: number | null
): Promise<AccountDeliveryDriverType[]> => {
    const { client } = await import('../../../../../graphql/client');
    let query;
    const variables: { accountIds: number[]; warehouseId?: number } = { accountIds };
    if (mode === ACCOUNTS_PAGE_MODE.CENTRAL) {
        query = GET_ACCOUNT_DELIVERY_DRIVERS_BY_IDS_FOR_CENTRAL;
    } else if (mode === ACCOUNTS_PAGE_MODE.WMS) {
        if (!warehouseId) {
            throw new Error('warehouseId is required in wms mode');
        }
        query = GET_ACCOUNT_DELIVERY_DRIVERS_BY_IDS_FOR_WMS;
        variables.warehouseId = warehouseId;
    } else if (mode === ACCOUNTS_PAGE_MODE.DSP) {
        query = GET_ACCOUNT_DELIVERY_DRIVERS_BY_IDS_FOR_DSP;
    } else {
        // 非三种入口之一时不发请求，不设默认入口
        return [];
    }
    const result = await client.query({
        query,
        variables,
        fetchPolicy: 'network-only'
    });
    return result.data.getAccountDeliveryDriversByIds;
};

